import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import { UserIdentity } from './userIdentity';
import redeemOTALink from './redeemOTALink';

/**
 * @deprecated please use `redeemOTALink`
 *
 * Redeem a magic link for a non-refreshable session.
 *
 * @param nonce
 *
 * @returns
 *
 * <details>
 * <summary>
 * On success (resolves)
 * </summary>
 *
 * ```json
 * {
 *   "uuid": "c7e9fed4-bedf-428b-a694-1bbd21721cf7",
 *   "accessToken": "c7e9fed4bedf428b.a6941bbd21721cf7...",
 * }
 * ```
 * </details>
 *
 * <details>
 * <summary>
 * On error (throws)
 * <p><span style="background-color:rgb(255, 99, 71); margin-right:1.25em; display:inline-block;"> &nbsp; Deprecated &nbsp; </span></p>
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/Authentication/loginWithMagicLink
 * ```
 * </details>
 */
export default function redeemMagicLink(nonce: string): Promise<UserIdentity | APIErrorResponse> {
  console.warn('[Arc Identity SDK]: redeemMagicLink is deprecated');
  return redeemOTALink(nonce);
}
